import request from 'assets/js/request.js';

export function quarterQuery(data) {
  return request({
    url: '/portfolio/gather/quarterQuery',
    method: 'post',
    data: data,
  });
}

export function taskQuery(data) {
  return request({
    url: '/portfolio/gather/taskQuery',
    method: 'post',
    data: data,
  });
}

export function deleteCompanyFile(data) {
  return request({
    url: '/portfolio/gather/deleteCompanyFile',
    method: 'post',
    data: data,
  });
}

export function replyAdd(data) {
  return request({
    url: '/portfolio/gather/replyAdd',
    method: 'post',
    data: data,
  });
}
